<template>
    <div>
        <van-divider>如有信息需要修改，请加微信联系CCA工作人员</van-divider>
        <p style="text-align:center">长按保存到相册</p>
        <div v-for="src in imgs" v-if="imgs.length>0" style="
            text-align: center;
            margin: 10px;
        ">
            <img style="
            width: 100%;" :src="src"/>
        </div>
        <div  style="
            text-align: center;
            margin: 10px;
        " v-if="imgs.length==0" >工作人员二维码未配置</div>

        <van-action-sheet
            v-model="ltShow"
            :actions="ltActions"
            cancel-text="取消"
            @select="onLtSelect"
            close-on-click-action
            @cancel="ltShow=false"
        />
    </div>
</template>

<style scoped="">
</style>
<script>
    import {
            Cell, CellGroup,Field,RadioGroup,Radio,DatetimePicker,Picker,NoticeBar,Button,Dialog
    } from 'vant';
import jquery from 'jquery';
    export default {
        name: 'qrcode2',
        components: {
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Field.name]: Field,
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [NoticeBar.name]: NoticeBar,
            [Button.name]: Button,
            [Dialog.name]: Dialog,
        },
        data: function () {
            return {
                pageData:{
                    'id' : this.$route.query.id,
                    'jiankangpics' :[],
                    'lingdui_list' :[],
                    'yundongyuan_list' :[],
                    'jiaolianyuan_list' :[],
                    'caipanyuan_list' :[]
                },
                formData:{
                    'id' : this.$route.query.id,
                },
                imgs:[],
                showTime:false,
                timeField:'',
                showStation:false,
                stationField:'',


                ltImgSrc: '',
                ltImgName: '',
                ltActions: [{name: '保存图片'}],

                ltShow: false,
            }
        },
        mounted: function () {
            let that = this;
            document.title = "食宿行信息修改";
            this.$api.get('/api/sai/confirmzhixucedetail', {
                'id':that.pageData.id
            }, r => {
                that.pageData = r.data;
                if(that.pageData.erweiimg2){
                    that.imgs =  that.pageData.erweiimg2;
                }


                if (window.isApp()) {
                // if (true) {
                setTimeout(() => {
                    jquery('img').each(function () {
                    jquery(this).unbind();
                    jquery(this).longPress(() => {
                        console.log('longPress', jquery(this).attr('src'));
                        that.ltImgSrc = jquery(this).attr('src')
                        that.ltImgName = that.fileNameFromUrl(that.ltImgSrc)
                        that.ltShow = true;
                    });
                    })
                }, 500);
                return false;
                }
            });

        },
        methods: {
        }
    }
</script>


// WEBPACK FOOTER //
// SaiConfirmQr2.vue?0cf8b86c